/* global Swiper */
// *******************************************************************************
// 1.0 - News Slider
// *******************************************************************************

const newsSliderElements = document.querySelectorAll('[data-slider="news-slider"]');

const newsSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 800,
  autoHeight: true,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 1,
      spaceBetween: 30,
      autoHeight: false,
    },
    1240: {
      slidesPerView: 1,
      spaceBetween: 32,
    }
  },
};

newsSliderElements.forEach((el) => {
  const newsSliderParent = el.closest('.sc-news-slider');
  const paginationElement = newsSliderParent.querySelector('.swiper-pagination');

  newsSliderOptions.pagination.el = paginationElement;

  // eslint-disable-next-line no-new
  new Swiper(el, newsSliderOptions);
});
